import React, { ReactNode, ComponentProps, CSSProperties } from 'react'
import { View, TouchableOpacity, Button } from 'react-native'

import HGText from './HGText'
import styles from './styles'

type Props = ComponentProps<typeof Button> & {
  title?: string | ReactNode
  type?: 'inverted'
  size?: 'large' | 'small' | null
  icon?: ReactNode
  disabled?: boolean
  style?: CSSProperties
}

const HGButton = (props: Props) => {
  const { title, disabled, icon, type, size, style, onPress } = props

  const buttonStyle = () => {
    const buttonStyle = [styles.button]

    if (type) {
      // if (type === 'destructive') buttonStyle.push(styles.buttonTypeDestructive)
      // if (type === 'info') buttonStyle.push(styles.buttonTypeInfo)
      if (type === 'inverted') buttonStyle.push(styles.buttonTypeInverted)
      // if (type === 'instagram') buttonStyle.push(styles.buttonTypeInstagram)
      // if (type === 'facebook') buttonStyle.push(styles.buttonTypeFacebook)
    }

    if (size) {
      if (size === 'large') buttonStyle.push(styles.buttonLarge)
      if (size === 'small') buttonStyle.push(styles.buttonSmall)
    }

    // if (disabled) buttonStyle.push(styles.buttonDisabled)
    buttonStyle.push(style)

    return buttonStyle
  }

  const _renderIcon = () => {
    return icon ? <HGText style={styles.iconBefore}>{icon}</HGText> : null
  }

  return (
    <TouchableOpacity
      style={buttonStyle()}
      activeOpacity={0.5}
      onPress={onPress}
      disabled={disabled}
    >
      <View style={[styles.buttonInner, disabled && styles.buttonDisabled]}>
        {_renderIcon()}

        <HGText
          style={[
            styles.textButton,
            type === 'inverted' && styles.textButtonInverted,
          ]}
        >
          {title}
        </HGText>
      </View>
    </TouchableOpacity>
  )
}

HGButton.defaultProps = {
  title: '',
  type: undefined,
  size: null,
  disabled: false,
  icon: null,
  style: undefined,
}

export default HGButton
